export const blue = {
  blue100: '#CFE6FE',
  blue200: '#A0CAFE',
  blue300: '#89AFF8',
  blue400: '#4C8FFB',
  blue500: '#1262FA',
  blue600: '#0D4BD7',
  blue700: '#0937B3',
  blue800: '#052790',
  blue900: '#031B77',
  surfaceBlue: '#027BB5',
  lightBlue: '#89B1FD',
};
